import { render, staticRenderFns } from "./RefereeTable.vue?vue&type=template&id=1bf6acd5&"
import script from "./RefereeTable.vue?vue&type=script&lang=js&"
export * from "./RefereeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports